import type { FieldFormattingVersion } from '@ardoq/api-types';

export type FilterColorEntry = {
  color: string;
  version: FieldFormattingVersion | undefined;
};

export type FilterColorData = {
  entities: Record<string, FilterColorEntry>;
};

const getComponentFilterColor = (
  filterColorData: FilterColorData,
  componentId: string
): FilterColorEntry | undefined => filterColorData.entities[componentId];

const getReferenceFilterColor = (
  filterColorData: FilterColorData,
  referenceId: string
): FilterColorEntry | undefined => filterColorData.entities[referenceId];

export const filterColorDataOperations = {
  getComponentFilterColor,
  getReferenceFilterColor,
};
